<template>
    <div>
        <div v-if="this.notifications.length" class="modal-wrap modal-backdrop">
        </div>
        <transition-group :name="transition" tag="div">
            <div
                    class="modal fade show"
                    :key="index + 0"
                    tabindex="-1"
                    role="dialog"
                    v-for="(item, index) in notifications"
            >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" v-html="item.title"></h5>
                            <button type="button" class="close" aria-label="Close" @click="closeOverlay(index)">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p class="fs13" v-html="item.message"></p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" aria-label="Close" @click="closeOverlay(index)">Sluiten</button>
                        </div>
                    </div>
                </div>
            </div>

        </transition-group>
    </div>

</template>
<script>
    import { EventBus } from "../../../events";

    export default {
        props: {
            timeout: {
                type: Number,
                default: 500000
            },
            transition: {
                type: String,
                default: 'slide-fade'
            },
            types: {
                type: Object,
                default: () => ({
                    base:    'alert',
                    success: 'alert-success',
                    danger:  'alert-danger',
                    warning: 'alert-warning',
                    info:    'alert-info'
                })
            },
            displayIcons: {
                type: Boolean,
                default: false
            },
            icons: {
                type: Object,
                default: () => ({
                    base:    'ion',
                    danger:  'ion-alert-circled',
                    success: 'ion-checkmark-round',
                    info:    'ion-information-circled',
                    warning: 'ion-alert-circled',
                })
            },
        },

        data: () => ({
            notifications: []
        }),

        created() {
            EventBus.$on(
                'flashOverlay', (message, title, type) => this.flash(message, title, type)
            );
        },

        methods: {
            flash(message, title, type) {
                type = type === undefined ? 'info' : type;

                this.notifications.push({
                    title,
                    message,
                    type,
                    typeObject: this.classes(this.types, type),
                    iconObject: this.classes(this.icons, type)
                });

                setTimeout(this.hide, this.timeout);
            },

            classes(propObject, type) {
                let classes = {};

                if(propObject.hasOwnProperty('base')) {
                    classes[propObject.base] = true;
                }
                if (propObject.hasOwnProperty(type)) {
                    classes[propObject[type]] = true;
                }

                return classes;
            },

            hide(item = this.notifications[0]) {
                let key = this.notifications.indexOf(item);
                this.closeOverlay(key);
            },
            closeOverlay(key) {
                this.notifications.splice(key, 1);
            }
        },
    }
</script>
<style scoped>
    .modal-wrap {
        position: fixed;
        right: 25px;
        top: 25px;
        opacity: 0.5;
    }
    .modal {
        display: block;
    }
    .modal-wrap {
        display: block;
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }
    /**
     * Fade transition styles
     */
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
        opacity: 0
    }

    /**
     * Bounce transition styles
     */
    .bounce-enter-active {
        animation: bounce-in .5s;
    }
    .bounce-leave-active {
        animation: bounce-in .5s reverse;
    }
    @keyframes bounce-in {
        0% {
            transform: scale(0);
        }
        50% {
            transform: scale(1.5);
        }
        100% {
            transform: scale(1);
        }
    }

    /**
     * Slide transition styles
     */
    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for <2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }
</style>